import type { LucideIcon } from 'lucide-react';
import {
  LayoutDashboard,
  Landmark,
  Tags,
  FolderKanban,
  Settings2,
  Users,
  Calculator,
  Building2,
  FileText,
  ScrollText,
  Wallet,
  BarChart3,
} from 'lucide-react';

export type NavSubItem = {
  to: string;
  label: string;
  end?: boolean;
};

export type NavItem = {
  to: string;
  label: string;
  icon: LucideIcon;
  end?: boolean;
  /** اگر باشد، آیتم‌های زیرمنو زیر همین گروه نمایش داده می‌شوند */
  children?: NavSubItem[];
};

function pathMatchesChild(pathname: string, child: NavSubItem): boolean {
  if (child.end) return pathname === child.to;
  return pathname === child.to || pathname.startsWith(`${child.to}/`);
}

export function isNavChildActive(pathname: string, item: NavItem): boolean {
  if (!item.children?.length) return false;
  return item.children.some((c) => pathMatchesChild(pathname, c));
}

/** رابط حسابداری کلاسیک — فقط نما و دادهٔ موقت مرورگر */
export const NAV_CORE: NavItem[] = [
  { to: '/', label: 'داشبورد', icon: LayoutDashboard, end: true },
  { to: '/projects', label: 'پروژه‌ها', icon: FolderKanban },
  { to: '/employees', label: 'کارمندان', icon: Users },
  { to: '/payroll-calculator', label: 'محاسبه حقوق', icon: Calculator },
  { to: '/expense-types', label: 'نوع هزینه‌ها', icon: Tags },
  { to: '/accounting-documents', label: 'اسناد حسابداری', icon: FileText },
  {
    to: '/cheque-books',
    label: 'چک‌ها',
    icon: ScrollText,
    children: [
      { to: '/cheque-books', label: 'دسته‌چک', end: true },
      { to: '/cheque-books/register', label: 'ثبت برگه چک' },
    ],
  },
  { to: '/accounting-bank-movements', label: 'گردش بانکی', icon: Wallet },
  {
    to: '/banks',
    label: 'بانک‌ها',
    icon: Building2,
    children: [
      { to: '/banks', label: 'لیست بانک‌ها', end: true },
      { to: '/banks/bsi', label: 'بانک صادرات — خانه' },
      { to: '/banks/bsi/transfer', label: 'انتقال صادراتی' },
      { to: '/banks/bsi/interbank', label: 'ساتنا / پایا / پل' },
      { to: '/banks/bsi/pending', label: 'قابل امضا' },
    ],
  },
  { to: '/bank-accounts', label: 'حساب‌های بانکی', icon: Landmark },
  {
    to: '/accounting-reports/account-turnover',
    label: 'گزارش‌ها',
    icon: BarChart3,
    children: [
      { to: '/accounting-reports/account-turnover', label: 'گردش حساب', end: true },
    ],
  },
  { to: '/accounting-settings', label: 'تنظیمات', icon: Settings2 },
];

export const ALL_NAV_SECTIONS: { title: string; items: NavItem[] }[] = [
  { title: 'حسابداری', items: NAV_CORE },
];
